//@flow

import styled from 'styled-components'
import { positioning } from '../../../helpers'

export default styled.li`
  ${positioning};
  list-style: none;
`
